import { createTheme } from '@mui/material/styles'
import typography from './typography.json'

let lightTheme = createTheme({
  palette: {
    mode: 'light',
    background: {},
    primary: {
      light: '#91B0FA', // theme.palette.primary.light
      main: '#2C63E5', // theme.palette.primary.main
      dark: '#264CA4', // theme.palette.primary.dark
      900: '#151E33', //theme.palette.primary[900]
      800: '#24428A', //theme.palette.primary[800]
      700: '#FFFBF0', //theme.palette.primary[700]
      200: '#BFD2FD', //theme.palette.primary[200]
      100: '#D7E3FE', //theme.palette.primary[100]
      50: '#F5F8FF', //theme.palette.primary[50]
      contrastText: '#F5F8FF', //theme.palette.primary.contrastText
    },
    secondary: {
      light: '#FFF7E6', //theme.palette.secondary.light
      main: '#FFCD59', //theme.palette.secondary.main
      dark: '#CC981F', //theme.palette.secondary.dark
      50: '#FFF7E5', ////theme.palette.secondary[50]
    },
    // support: {
    success: {
      light: '#C2FAEA', //theme.palette.support.success.light
      main: '#00C28B', //theme.palette.support.success.main
      dark: '#008F66', //theme.palette.support.success.dark
      contrastText: '#C2FAEA', //theme.palette.support.success.contrastText
      100: '#EBFFF9', //theme.palette.support.success[100]
    },
    error: {
      light: '#F9D7D7', //theme.palette.support.error.light
      main: '#FF5757', //theme.palette.support.error.main
      dark: '#CC3333', //theme.palette.support.error.dark
      contrastText: '#F9D7D7', //theme.palette.support.error.contrastText
      100: '#FFEEEE', //theme.palette.support.error[100]
      50: '#FFFAEF', //theme.palette.support.error[50]
    },
    warning: {
      light: '#FFECDB', //theme.palette.support.warning.light
      main: '#F2984A', //theme.palette.support.warning.main
      dark: '#D97E2E', //theme.palette.support.warning.dark
      600: '#D97F30', //theme.palette.support.warning[600]
      contrastText: '#FFECDB', //theme.palette.support.warning.contrastText
    },
    // },
    grey: {
      50: '#F8F8F8', //theme.palette.grey[50]
      100: '#A1A1A1', //theme.palette.grey[100]
      150: '#F2F2F2', // grey50  //theme.palette.grey[150]
      300: '#E3E3E3', // grey100 //theme.palette.grey[300]
      350: '#C7C7C7', // grey200 //theme.palette.grey[350]
      650: '#666666', // grey500 //theme.palette.grey[650]
      700: '#EBEBEB', //theme.palette.grey[700]
      black: '#1A1A1A', //theme.palette.grey.black
    },
    common: {
      black: '#1A1A1A', //theme.palette.common.black
      dark: '#292929', //theme.palette.common.dark
      light: '#3D3D3D', //theme.palette.common.light
      white: '#ffffff', //theme.palette.common.white
    },
  },
  typography: {
    ...typography,
  },
})

lightTheme = createTheme(lightTheme, {
  palette: {
    warning: lightTheme.palette?.warning,
    error: lightTheme.palette?.error,
    success: lightTheme.palette?.success,
  },
})

lightTheme = createTheme(lightTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        sizeSmall: {
          minWidth: '98px',
          height: 32,
          ...lightTheme.typography.h6,
          padding: '8px 16px',
          textTransform: 'none',
        },
        sizeMedium: {
          minWidth: '120px',
          height: '40px',
          ...lightTheme.typography.h5,
          padding: '10px 24px',
          textTransform: 'none',
        },
        sizeLarge: {
          minWidth: '161px',
          height: '48px',
          ...lightTheme.typography.h4,
          padding: '12px 32px',
          textTransform: 'none',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        columnHeaders: {
          backgroundColor: '#F8F8F8',
          boxSizing: 'border-box',
          borderRadius: 0,
        },
        columnHeader: {
          height: 48,
          color: '#1A1A1A',
          '&:focus': {
            outline: 'none !important',
          },
          '& .MuiDataGrid-iconButtonContainer': {
            visibility: 'visible !important',
            width: 'auto !important',
          },
          '&:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon': {
            opacity: 0.5,
          },
          '&:hover': {
            outline: 'none !important',
          },
          '& .MuiCheckbox-root': {
            paddingRight: '0px !important',
          },
        },
        cell: {
          '& .MuiCheckbox-root': {
            paddingRight: 0,
          },
          lineHeight: '56px',
          "$ [aria-selected='true']": {
            backgroundColor: lightTheme.palette.primary.contrastText,
          },
          "$ [aria-selected='false']": {
            backgroundColor: lightTheme.palette.common.white,
          },
          ...lightTheme.typography.body1,
          '&:focus': {
            outline: 'none !important',
          },
          '&:focus-within': {
            outline: 'none !important',
          },
        },
        row: {
          "$ [aria-selected='true']": {
            backgroundColor: lightTheme.palette.primary.contrastText,
          },
          "$ [aria-selected='false']": {
            backgroundColor: lightTheme.palette.common.white,
          },
          '&:hover': {
            backgroundColor: lightTheme.palette.primary.contrastText,
          },
        },

        header: {
          ...lightTheme.typography.h5,
          height: 56,
          boxSizing: 'border-box',
        },
        columnHeaderTitle: {
          ...lightTheme.typography.h5,
        },
        columnSeparator: {
          display: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        sizeSmall: {
          width: 'auto',
          height: 32,
          padding: '8px 0px',
          ...lightTheme.typography.body2,
          borderRadius: 5000,
        },
        sizeMedium: {
          // minWidth: 90,
          height: 40,
          padding: '10px 0px',
          ...lightTheme.typography.body1,
          borderRadius: 5000,
        },
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          borderRadius: `4px`,
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          width: 328,
          position: 'relative',
          minWidth: 360,
          padding: `8px 16px`,
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          ...lightTheme.typography.body2,
          height: 32,

          '& ul>li>button.Mui-selected': {
            backgroundColor: lightTheme.palette.primary.main,
            color: lightTheme.palette.common.white,
          },
          '& ul>li>button:hover': {
            backgroundColor: `rgba(0, 0, 0, 0.04)`,
          },
          '& ul>li>button:hover.Mui-selected': {
            color: lightTheme.palette.primary.contrastText,
            backgroundColor: lightTheme.palette.primary.main,
          },
          '& ul>li>button:hover.Mui-selected:hover': {
            backgroundColor: lightTheme.palette.primary.dark,
          },
          '& svg': {
            fill: lightTheme.palette.primary.main,
          },
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          //display: "none",
          // margin: 0,
          // padding: 0,
          // zIndex: 999,
          // position: 'absolute',
          //top: 58,
          // "& p": {
          //     padding: "6px 16px",
          //     cursor: "pointer",
          //     "&:hover": {
          //         backgroundColor:
          //             lightTheme.palette.primary.contrastText,
          //     },
          // },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          marginBottom: '4px',
          '&>span': {
            color: lightTheme.palette?.error?.main,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: (props) => ({
          '&::placeholder': {
            color: props.disabled ? lightTheme.palette.grey[100] : lightTheme.palette.grey[650],
            opacity: `1 !important`,
            fontFamily: 'Source Sans Pro, sans-serif, FontAwesome',
          },
          backgroundColor: props.disabled
            ? lightTheme.palette.grey[150]
            : lightTheme.palette.common.white,
        }),
      },
    },

    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: lightTheme.palette.grey[100],
            cursor: 'not-allowed',
          },
        },
        // root: {},
        // disabled: {
        //   color: lightTheme.palette.grey[100],
        //   cursor: 'not-allowed',
        // },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          //   borderBottom: "none",
          padding: '12px 8px',
          ...lightTheme.typography.body2,
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          paddingLeft: lightTheme.spacing(2),
          paddingRight: lightTheme.spacing(1),
        },
      },
    },
  },
})

export default lightTheme
